import NGSubcategoryData from '@/utils/classes/NGSubcategoryData';

export default {
  general: {
    name: 'General',
    priority: 1,
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      goals: new NGSubcategoryData(
        [12, 55, '35_r', '54_r'],
        null /*[40]*/,
        { accomplished: 1, received: 0 },
        'Goles',
        'Goles recibidos',
        'Goles realizados / recibidos',
        'Goles recibidos / realizados',
        1,
      ),
      shotToGoal: new NGSubcategoryData(
        [91, 95, 158, 167, 176, 343, 330, 333, 423],
        null,
        { accomplished: 2, received: 0 },
        'Remates a destino',
        '',
        '',
        '',
        1,
      ),
      possession: new NGSubcategoryData(
        [2, 3, 20, 21],
        null,
        { accomplished: 3, received: 0 },
        'Posesión',
        '',
        '',
        '',
        1,
        false,
        true,
      ),
      yellowCards: new NGSubcategoryData(
        [14, 52],
        null,
        { accomplished: 4, received: 0 },
        'Tarjetas amarillas',
        '',
        '',
        '',
        1,
      ),
      redCards: new NGSubcategoryData(
        [15, 53],
        null,
        { accomplished: 5, received: 0 },
        'Tarjetas rojas',
        '',
        '',
        '',
        1,
      ),
      centerCrosses: new NGSubcategoryData(
        [13, 25],
        null,
        { accomplished: 6, received: 0 },
        'Centros totales',
        '',
        '',
        '',
        1,
      ),
    },
  },
  offensive: {
    name: 'Ofensivo',
    priority: 2,
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      shotsOnGoal: new NGSubcategoryData([19], null, { accomplished: 7, received: 0 }, 'Tiros a gol', '', '', '', 1),
      shotsOnGoalDestination: new NGSubcategoryData(
        [91, 95],
        null,
        { accomplished: 8, received: 0 },
        'Tiros a gol destino',
        '',
        '',
        '',
        1,
      ),
      shotToGoal: new NGSubcategoryData(
        [91, 95, 158, 167, 176, 343, 330, 333, 423],
        null,
        { accomplished: 2, received: 0 },
        'Remates a destino',
        '',
        '',
        '',
        1,
      ),
      ballsWonOpponentPenaltyBox: new NGSubcategoryData(
        [11],
        null,
        { accomplished: 10, received: 0 },
        'Balones ganados área rival',
        '',
        '',
        '',
        1,
      ),
      centersFromRight: new NGSubcategoryData(
        [25],
        null,
        { accomplished: 11, received: 0 },
        'Centros por derecha',
        '',
        '',
        '',
        1,
      ),
      centersFromLeft: new NGSubcategoryData(
        [13],
        null,
        { accomplished: 12, received: 0 },
        'Centros por izquierda',
        '',
        '',
        '',
        1,
      ),
      success1VS1: new NGSubcategoryData(
        [4],
        null,
        { accomplished: 13, received: 0 },
        'Enfrentamientos ofensivos exitosos',
        '',
        '',
        '',
        1,
      ),
      unsuccess1VS1: new NGSubcategoryData(
        [209],
        null,
        { accomplished: 14, received: 0 },
        'Enfrentamientos ofensivos no exitosos',
        '',
        '',
        '',
        1,
      ),
    },
  },
  defensive: {
    name: 'Defensivo',
    priority: 3,
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      saves: new NGSubcategoryData([39], null, { accomplished: 15, received: 0 }, 'Atajadas', '', '', '', 1),
      ballsWonOwnPenaltyBox: new NGSubcategoryData(
        [23],
        null,
        { accomplished: 16, received: 0 },
        'Balones ganados área propia',
        '',
        '',
        '',
        1,
      ),
      success1VS1: new NGSubcategoryData(
        [5],
        null,
        { accomplished: 17, received: 0 },
        'Enfrentamientos defensivos exitosos',
        '',
        '',
        '',
        1,
      ),
      unsuccess1VS1: new NGSubcategoryData(
        [209],
        null,
        { accomplished: 18, received: 0 },
        'Enfrentamientos defensivos no exitosos',
        '',
        '',
        '',
        1,
      ),
      aerialGame: new NGSubcategoryData(
        [24],
        null,
        { accomplished: 19, received: 0 },
        'Juego aéreo resto del campo',
        '',
        '',
        '',
        1,
      ),
      clearances: new NGSubcategoryData([34], null, { accomplished: 20, received: 0 }, 'Rechaces', '', '', '', 1),
    },
  },
  possession: {
    name: 'Posesión',
    priority: 4,
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      totalPasses: new NGSubcategoryData(
        [2, 3, 20, 21],
        null,
        { accomplished: 21, received: 0 },
        'Pases totales',
        '',
        '',
        '',
        1,
      ),
      successPasses: new NGSubcategoryData(
        [2, 20],
        null,
        { accomplished: 22, received: 0 },
        'Pases acertados',
        '',
        '',
        '',
        1,
      ),
      successPassesRivalHalf: new NGSubcategoryData(
        [20],
        null,
        { accomplished: 23, received: 0 },
        'Pases acertados en cancha rival',
        '',
        '',
        '',
        1,
      ),
      ballsRecoveredInChallenge: new NGSubcategoryData(
        [483],
        null,
        { accomplished: 24, received: 0 },
        'Balones recuperados en disputa',
        '',
        '',
        '',
        1,
      ),
      ballsRecoveredWithoutChallenge: new NGSubcategoryData(
        [484],
        null,
        { accomplished: 25, received: 0 },
        'Balones recuperados sin disputa',
        '',
        '',
        '',
        1,
      ),
      ballsLostInChallenge: new NGSubcategoryData(
        [494],
        null,
        { accomplished: 26, received: 0 },
        'Balones perdidos en disputa',
        '',
        '',
        '',
        1,
      ),
      ballsLostWithoutChallenge: new NGSubcategoryData(
        [495],
        null,
        { accomplished: 27, received: 0 },
        'Balones perdidos sin disputa',
        '',
        '',
        '',
        1,
      ),
    },
  },
  stoppedBall: {
    name: 'Balón parado',
    priority: 5,
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      freeKick44: new NGSubcategoryData(
        [155, 164, 173, 362, 371, 380],
        null,
        { accomplished: 28, received: 0 },
        'Tiros libres 4/4',
        '',
        '',
        '',
        1,
      ),
      freeKick34: new NGSubcategoryData(
        [150, 357],
        null,
        { accomplished: 29, received: 0 },
        'Tiros libres 3/4',
        '',
        '',
        '',
        1,
      ),
      freeKickOwnHalf: new NGSubcategoryData(
        [149, 356],
        null,
        { accomplished: 30, received: 0 },
        'Tiros libres cancha propia',
        '',
        '',
        '',
        1,
      ),
      cornerFromRight: new NGSubcategoryData(
        [32],
        null,
        { accomplished: 31, received: 0 },
        'Tiros de esquina por derecha',
        '',
        '',
        '',
        1,
      ),
      cornerFromLeft: new NGSubcategoryData(
        [31],
        null,
        { accomplished: 32, received: 0 },
        'Tiros de esquina por izquierda',
        '',
        '',
        '',
        1,
      ),
      goalKick: new NGSubcategoryData(
        [264, 28],
        null,
        { accomplished: 33, received: 0 },
        'Saques de meta',
        '',
        '',
        '',
        1,
      ),
    },
  },
  penalties: {
    name: 'Infracciones',
    priority: 6,
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      totalFouls: new NGSubcategoryData(
        [17, 50],
        null,
        { accomplished: 34, received: 0 },
        'Faltas totales',
        '',
        '',
        '',
        1,
      ),
      foulOwnGoal: new NGSubcategoryData(
        [348, 478],
        null,
        { accomplished: 35, received: 0 },
        'Faltas cerca de su propia portería',
        '',
        '',
        '',
        1,
      ),
      fieldFouls: new NGSubcategoryData(
        [349, 350, 479, 480],
        null,
        { accomplished: 36, received: 0 },
        'Faltas resto del campo',
        '',
        '',
        '',
        1,
      ),
      penaltyKick: new NGSubcategoryData(
        [461, 481],
        null,
        { accomplished: 37, received: 0 },
        'Penales cometidos',
        '',
        '',
        '',
        1,
      ),
      offside: new NGSubcategoryData([33], null, { accomplished: 38, received: 0 }, 'Fueras de lugar', '', '', '', 1),
    },
  },
  /*gameResult: {
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      goals: new NGSubcategoryData(
        [12, 55, '35_r', '54_r'],
        [40],
        { accomplished: 1, received: 2 },
        'Goles',
        'Goles recibidos',
        'Goles realizados / recibidos',
        'Goles recibidos / realizados',
        1,
      ),
      shotsOnGoal: new NGSubcategoryData(
        [510],
        [510],
        { accomplished: 3, received: 4 },
        'Tiros a gol',
        'Tiros a gol recibidos',
        'Tiros a gol realizados / recibidos',
        'Tiros a gol recibidos / realizados',
        2,
      ),
      leftCenteringPass: new NGSubcategoryData(
        [13],
        [25],
        { accomplished: 5, received: 9 },
        'Centros por izquierda',
        'Centros por derecha recibidos',
        'Centros por izquierda realizados / derecha recibidos',
        'Centros por derecha recibidos / izquierda realizados',
        3,
      ),
      rightCenteringPass: new NGSubcategoryData(
        [25],
        [13],
        { accomplished: 6, received: 10 },
        'Centros por derecha',
        'Centros por izquierda recibidos',
        'Centros por derecha realizados / izquierda recibidos',
        'Centros por izquierda recibidos / derecha realizados',
        4,
      ),
      successfulOneOnOne: new NGSubcategoryData(
        [4, 611],
        [5, 612],
        { accomplished: 7, received: 11 },
        '1vs1 exitosos ofensivos',
        '1v1 exitosos defensivos',
        '1vs1 exitosos ofensivos / defensivos',
        '1vs1 exitosos defensivos / ofensivos',
        5,
      ),
      recoveredBallsRivalField: new NGSubcategoryData(
        [11],
        [23],
        { accomplished: 8, received: 12 },
        'Balones ganados en área rival',
        'Balones ganados en área propia',
        'Balones ganados en área rival / propia',
        'Balones ganados en área propia / rival',
        6,
      ),
    },
  },
  possession: {
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1],
      analysisTypeBlocks: [2],
    },
    subcategories: {
      totalPasses: new NGSubcategoryData([2, 20], null, { accomplished: 13, received: 0 }, 'Pases acertados totales'),
      ownFieldPasses: new NGSubcategoryData(
        [2],
        null,
        { accomplished: 14, received: 0 },
        'Pases acertados cancha propia',
      ),
      rivalPasses: new NGSubcategoryData([20], null, { accomplished: 15, received: 0 }, 'Pases acertados cancha rival'),
      firstQuarterPasses: new NGSubcategoryData([213], null, { accomplished: 16, received: 0 }, 'Pases acertados 1/4'),
      secondQuarterPasses: new NGSubcategoryData([214], null, { accomplished: 17, received: 0 }, 'Pases acertados 2/4'),
      thirdQuarterPasses: new NGSubcategoryData([215], null, { accomplished: 69, received: 0 }, 'Pases acertados 3/4'),
      fourthQuarterPasses: new NGSubcategoryData([216], null, { accomplished: 18, received: 0 }, 'Pases acertados 4/4'),
      recoveredBallsRivalField: new NGSubcategoryData(
        [487, 488, 491, 492],
        null,
        { accomplished: 19, received: 0 },
        'Balones recuperados cancha rival',
      ),
      recoveredBallsOwnField: new NGSubcategoryData(
        [485, 486, 489, 490],
        null,
        { accomplished: 20, received: 0 },
        'Balones recuperados cancha propia',
      ),
    },
  },
  goalOrigin: {
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [1, 2],
      analysisTypeBlocks: [2, 3],
    },
    subcategories: {
      centerByLeft: new NGSubcategoryData(
        [62],
        [63],
        { accomplished: 21, received: 32 },
        'O. centro por izquierda',
        'O. centro por derecha recibido',
        'O. centro por izquierda realizado / derecha recibido',
        'O. centro por derecha recibido / izquierda realizado',
        7,
      ),
      centerByRight: new NGSubcategoryData(
        [63],
        [62],
        { accomplished: 22, received: 33 },
        'O. centro por derecha',
        'O. centro por izquierda recibido',
        'O. centro por derecha realizado / izquierda recibido',
        'O. centro por izquierda recibido / derecha realizado',
        8,
      ),
      cornerByLeft: new NGSubcategoryData(
        [64],
        [68],
        { accomplished: 23, received: 34 },
        'O. corner por izquierda',
        'O. corner por derecha recibido',
        'O. corner por izquierda realizado / derecha recibido',
        'O. corner por derecha recibido / izquierda realizado',
        9,
      ),
      cornerByRight: new NGSubcategoryData(
        [68],
        [64],
        { accomplished: 24, received: 35 },
        'O. corner por derecha',
        'O. corner por izquierda recibido',
        'O. corner por derecha realizado / izquierda recibido',
        'O. corner por izquierda recibido / derecha realizado',
        10,
      ),
      filteredBallLastLine: new NGSubcategoryData(
        [73],
        [73],
        { accomplished: 25, received: 36 },
        'O. balón filtrado última línea',
        'O. balón filtrado última línea recibido',
        'O. balón filtrado última línea realizado / recibido',
        'O. balón filtrado última línea recibido / realizado',
        11,
      ),
      longPass: new NGSubcategoryData(
        [74],
        [74],
        { accomplished: 26, received: 37 },
        'O. pase largo',
        'O. pase largo recibido',
        'O. pase largo realizado / recibido',
        'O. pase largo recibido / realizado',
        12,
      ),
      successfulOffensiveOneOnOne: new NGSubcategoryData(
        [88],
        [88],
        { accomplished: 27, received: 38 },
        'O. 1vs1 exitoso ofensivo',
        'O. 1vs1 exitoso ofensivo recibido',
        'O. 1vs1 exitoso ofensivo realizado / recibido',
        'O. 1vs1 exitoso ofensivo recibido / realizado',
        13,
      ),
      freeKick: new NGSubcategoryData(
        [81],
        [81],
        { accomplished: 28, received: 39 },
        'O. tiro libre',
        'O. tiro libre recibido',
        'O. tiro libre realizado / recibido',
        'O. tiro libre recibido / realizado',
        14,
      ),
      recoveredBallRivalField: new NGSubcategoryData(
        [76],
        [76],
        { accomplished: 29, received: 40 },
        'O. balón recuperado en cancha rival',
        'O. balón recuperado en cancha rival recibido',
        'O. balón recuperado en cancha rival realizado / recibido',
        'O. balón recuperado en cancha rival recibido / realizado',
        15,
      ),
      throwIn: new NGSubcategoryData(
        [89],
        [89],
        { accomplished: 30, received: 41 },
        'O. saque de banda',
        'O. saque de banda recibido',
        'O. saque de banda realizado / recibido',
        'O. saque de banda recibido / realizado',
        16,
      ),
      penalty: new NGSubcategoryData(
        [389],
        [389],
        { accomplished: 31, received: 42 },
        'O. penal',
        'O. penal recibido',
        'O. penal realizado / recibido',
        'O. penal recibido / realizado',
        17,
      ),
    },
  },
  goals: {
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [2],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      fromInsidePenaltyArea: new NGSubcategoryData(
        [57],
        [57],
        { accomplished: 43, received: 48 },
        'Gol pie dentro del área',
        'Gol pie dentro del área recibido',
        'Gol pie dentro del área realizado / recibido',
        'Gol pie dentro del área recibido / realizado',
        18,
      ),
      fromOutsidePenaltyArea: new NGSubcategoryData(
        [326],
        [326],
        { accomplished: 44, received: 49 },
        'Gol pie desde fuera del área en jugada',
        'Gol pie desde fuera del área en jugada recibido',
        'Gol pie desde fuera del área en jugada realizado / recibido',
        'Gol pie desde fuera del área en jugada recibido / realizado',
        19,
      ),
      head: new NGSubcategoryData(
        [56],
        [56],
        { accomplished: 45, received: 50 },
        'Gol de cabeza',
        'Gol de cabeza recibido',
        'Gol de cabeza realizado / recibido',
        'Gol de cabeza recibido / realizado',
        20,
      ),
      freeKick: new NGSubcategoryData(
        [60],
        [60],
        { accomplished: 46, received: 51 },
        'Gol de tiro libre',
        'Gol de tiro libre recibido',
        'Gol de tiro libre realizado / recibido',
        'Gol de tiro libre recibido / realizado',
        21,
      ),
      penalty: new NGSubcategoryData(
        [59],
        [59],
        { accomplished: 47, received: 52 },
        'Gol de penal',
        'Gol de penal recibido',
        'Gol de penal realizado / recibido',
        'Gol de penal recibido / realizado',
        22,
      ),
    },
  },
  cornerKicks: {
    parentInfo: {
      // See inside src/data/next/options.js, id property inside constant analysisTypeOptions
      // and
      // block property inside constant filterOptions to see where these numbers come from
      parentAnalysis: [3],
      analysisTypeBlocks: [1],
    },
    subcategories: {
      cornerKick: new NGSubcategoryData(
        [31, 32],
        [31, 32],
        { accomplished: 53, received: 61 },
        'Tiros de esquina',
        'Tiros de esquina recibidos',
        'Tiros de esquina realizados / recibidos',
        'Tiros de esquina recibidos / realizados',
        31,
      ),
      firstQuarterFaults: new NGSubcategoryData(
        [348, 478],
        [354, 476],
        { accomplished: 54, received: 65 },
        'Faltas 1/4',
        'Faltas 4/4 recibidas',
        'Faltas 1/4 realizadas / Faltas 4/4 recibidas',
        'Faltas 4/4 recibidas / Faltas 1/4 realizadas',
        23,
      ),
      secondQuarterFaults: new NGSubcategoryData(
        [349, 479],
        [353, 475],
        { accomplished: 55, received: 64 },
        'Faltas 2/4',
        'Faltas 3/4 recibidas',
        'Faltas 2/4 realizadas / Faltas 3/4 recibidas',
        'Faltas 3/4 recibidas / Faltas 2/4 realizadas',
        24,
      ),
      rivalFieldFaults: new NGSubcategoryData(
        [350, 480],
        [352, 474],
        { accomplished: 56, received: 62 },
        'Faltas cancha rival',
        'Faltas cancha propia recibidas',
        'Faltas cancha rival realizadas / Faltas cancha propia recibidas',
        'Faltas cancha propia recibidas / Faltas cancha rival realizadas',
        25,
      ),
      totalFaults: new NGSubcategoryData(
        [17, 50],
        [18, 49],
        { accomplished: 58, received: 66 },
        'Faltas totales',
        'Faltas totales recibidas',
        'Faltas totales realizadas / recibidas',
        'Faltas totales recibidas / realizadas',
        26,
      ),
      throwIn: new NGSubcategoryData(
        [210, 212],
        [210, 212],
        { accomplished: 59, received: 67 },
        'Saques de banda',
        'Saques de banda recibidos',
        'Saques de banda realizados / recibidos',
        'Saques de banda recibidos / realizados',
        27,
      ),
      penalty: new NGSubcategoryData(
        [465, 481],
        [466, 477],
        { accomplished: 60, received: 68 },
        'Penales',
        'Penales recibidos',
        'Penales realizados / recibidos',
        'Penales recibidos / realizados',
        28,
      ),
      save: new NGSubcategoryData(
        [39],
        [39],
        { accomplished: 70, received: 70 },
        'Atajada',
        'Atajada recibidas',
        'Atajada realizadas / recibidas',
        'Atajada recibidas / realizadas',
        29,
        true,
      ),
      goalKick: new NGSubcategoryData(
        [28, 264],
        [28, 264],
        { accomplished: 71, received: 71 },
        'Saque de meta',
        'Saque de meta recibidos',
        'Saque de meta realizados / recibidos',
        'Saque de meta recibidos / realizados',
        30,
        true,
      ),
    },
  },*/
};
